'use client';

import { usePathname } from 'next/navigation';

/**
 * `proxy.js` rewrites every page request to `/<requestContext>/...` for the
 * precompute pattern, so on the server `usePathname()` includes that encoded
 * segment (`/eyJ2YXJpYW50UGFyYW1zIjoi.../cart`) while the browser only ever
 * sees the public URL (`/cart`).
 *
 * Any client component that *branches its markup* on the pathname will
 * therefore render differently on the server than on the client and blow up
 * hydration. Use this instead of `usePathname()` for those cases.
 */
export function useAppPathname() {
  return stripRequestContext(usePathname());
}

/**
 * Drops the leading `[requestContext]` segment, if there is one. The segment is
 * base64url-encoded JSON (see `lib/middleware/request-context.ts`), so it always
 * starts with `eyJ` which is the encoding of `{"`.
 */
export function stripRequestContext(pathname) {
  return pathname?.replace(/^\/eyJ[\w-]*/, '') || '/';
}
